import { render, staticRenderFns } from "./CmsB2BGroupsActivityTable.vue?vue&type=template&id=5d385c48&scoped=true"
import script from "./CmsB2BGroupsActivityTable.vue?vue&type=script&lang=ts"
export * from "./CmsB2BGroupsActivityTable.vue?vue&type=script&lang=ts"
import style0 from "./CmsB2BGroupsActivityTable.vue?vue&type=style&index=0&id=5d385c48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d385c48",
  null
  
)

export default component.exports